module.exports = __webpack_public_path__ + "static/img/modal-success.42df40fd.png";